import moment from "moment";
import { PremFixture } from "../models";
import "./PremFixtureRow.css";

const Scorers = ({ text, icon, right, muted }: { text: string | null; icon: string; right?: boolean; muted?: boolean }) => {
	if (!text) {
		return null;
	}
	return (
		<div className={`prem-scorers${right ? " right" : ""}${muted ? " muted-line" : ""}`}>
			{!right && <i className={icon} />}
			<span>{text}</span>
			{right && <i className={icon} />}
		</div>
	);
};

export const PremFixtureRow = ({ fixture: f }: { fixture: PremFixture }) => {
	const scheduled = !f.live && !f.finished;
	return (
		<div className={`prem-row card${f.live ? " live" : ""}`}>
			<div className="prem-side">
				<div className="prem-team">{f.homeTeam}</div>
				<Scorers text={f.homeGoalsDesc} icon="ri-football-line" />
				<Scorers text={f.homeAssistsDesc} icon="ri-crosshair-line" muted />
			</div>
			<div className="prem-centre">
				{scheduled ? (
					<div className="prem-kickoff mono">{moment(f.start).format("ddd HH:mm")}</div>
				) : (
					<>
						<div className="prem-score mono">
							{f.homeGoals}–{f.awayGoals}
						</div>
						<div className={`prem-status mono${f.live ? " live" : ""}`}>
							{f.live && <span className="live-dot" />}
							{f.live ? `${f.minutes}′` : "FT"}
						</div>
					</>
				)}
			</div>
			<div className="prem-side right">
				<div className="prem-team">{f.awayTeam}</div>
				<Scorers text={f.awayGoalsDesc} icon="ri-football-line" right />
				<Scorers text={f.awayAssistsDesc} icon="ri-crosshair-line" right muted />
			</div>
		</div>
	);
};
